import React from 'react';
import { defaultHeroMetricsColors, ProgressBar } from '@/components/display/progress-bar';

type PacingProgressBarProps = {
  pacing: string;
  planned: string;
  remaining: string;
  pacingRaw: number;
};

export function PacingProgressBar({
  pacing,
  planned,
  remaining,
  pacingRaw
}: PacingProgressBarProps) {
  return (
    <div className="flex flex-col gap-2 grow">
      <div className="flex items-baseline justify-between">
        <span className="text-sm text-[#181d1f]">
          <span className="font-semibold">{pacing}</span> of {planned}
        </span>
        <span className="text-xs text-gray-500">{remaining} remaining</span>
      </div>
      <ProgressBar percent={pacingRaw * 100} colors={defaultHeroMetricsColors} />
    </div>
  );
}
